import React, { useEffect, useState } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import SubHeader from '../components/SubHeader'
import CommonTable from '../components/Common_table'
import { useGlobalContext } from '../../context/Context';
// import Editorder from '../../Admin/components/Edit_order'
import Vieworder from '../../Admin/components/View_order'
import instance from '../../Utils/api'
import CircularProgress from '@mui/material/CircularProgress';
import Assignorder from '../components/Assign_order';
import Deadlineorder from '../components/Deadline_order';
import Adddocuments from '../components/Add_documents'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Orderstatus from '../components/Order_status'
import Fabricstatus from '../components/Fabric_status'
import DownloadExportData from '../../Utils/excel'
import Assigntailor from '../components/Assign_Tailor'
import Suborderstatus from '../components/Suborder_status'
import UploadImage from '../components/UploadImage'

const Suborders = () => {
    const tabsData = [
        {
            label: "All",
            name: "",
            options: []
        },
        {
            label: "Assigned SubOrders",
            name: "Assigned",
            options: ['Assigned']
        },
        {
            label: "UnAssigned SubOrders",
            name: "Unassigned",
            options: ['Unassigned']
        },
    ]
    const title = { name: "Orders", subheading: "Follow-up on Sub orders", search: "Search Sub orders", button: "Add order" }
    const statusOptions = ['None', 'New Order received', 'Designer Assigned', 'Estimate Sent', 'Estimate approved by Customer', 'Order In Progress', 'Order Ready', 'Delivery Scheduled', 'Order Delivered', 'Alteration request raised'];
    const designkindoptins = ['None', 'CustomDesign', 'Design']
    const fabricStatusOptions = ['None', 'Pending', 'Acquired']

    const columns = [
        { label: "S.No", field: "sno", },
        { label: "Sub Order Id", field: "order_id", },
        { label: "Name", field: "name", },
        { label: "Location", field: "location", },
        { label: "Design kind", field: "design_kind", },
        { label: "Assign Person", field: "Assignperson", },
        { label: "SubOrder Status", field: "Orderstatus", },
        // { label: "Assign Tailor", field: "Assigntailor",  },
        { label: "Fabric given", field: "consultationsleft", },
        // { label: "Fabric Status", field: "fabricstatus", },
        { label: "Deadline", field: "Deadline", },
        { label: "Total Amount", field: "amount", },
        // { label: "Document", field: "suborder",  },
        // { label: "Final Image", field: "preview",  },
        // { label: "Actions", field: "action",  },
        // { label: "mobile Number", field: "mobile",  },
        // { label: "Date of Bith", field: "DateofBith",  },
        // { label: "Gender", field: "gender",  },
        // { label: "size", field: "size",  },
        // { label: "Status", field: "Status",  },
        // { label: "Ordered Date", field: "ordereddate",  },
        // { label: "Delivered Date", field: "delivereddate",  },
        // { label: "Assigned Person", field: "assignedperson",  },
    ];

    //usestate define
    const { categoryId } = useParams();
    const { loading, setLoading } = useGlobalContext();
    const { openDialog, setOpenDialog } = useGlobalContext();
    const { openviewDialog, setopenviewDialog } = useGlobalContext();
    const { statusDialog, setstatusDialog } = useGlobalContext();
    const { deleteDialog, setdeleteDialog } = useGlobalContext();
    const { commonDialog, setCommonDialog } = useGlobalContext();
    const { imageDialog, setImageDialog } = useGlobalContext();
    const { openConsultationDialog, setOpenConsultationDialog } = useGlobalContext();
    const [openLoginDialog, setOpenLoginDialog] = useState(false); // Login modal state
    const [suborders, setSubOrder] = useState([]);
    const [assignDialog, setAssignDialog] = useState(false);
    const [selectedsubOrder, setSelectedsubOrder] = useState(null);
    const [getSubOrder, setgetSubOrder] = useState(false);
    const [totalpages, setTotalPages] = useState();
    const [currentPage, setCurrentPages] = useState(1);
    const [totalCount, setTotalcount] = useState();
    const [search, setSearch] = useState();
    const [tabSearch, setTabSearch] = useState();
    const [status, setStatus] = useState(categoryId ? categoryId : "");
    const [design_kind, SetDesignType] = useState();
    const [fabric_status, SetFabricStatus] = useState();
    const rowsperpage = 10;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [download, setDownload] = useState(false);
    const [searchparams] = useSearchParams();
    const filter = searchparams.get('filtertype');
    const startDate = searchparams.get('startDate');
    const endDate = searchparams.get('endDate');
    const navigate = useNavigate();

    //order fetching
    const fetchsuborder = async (search, currentPage, rowsperpage, tabSearch, download, filter, startDate, endDate, fabric_status, design_kind, status) => {
        const params = {
            search,
            page: currentPage,
            ...(download ? { page: 1 } : { page: currentPage }),
            ...(download
                ? { limit: totalpages * rowsperpage }
                : { limit: rowsperpage }
            ),
            // ...(!download ? { limit: rowsperpage } : { limit: totalpages * rowsperpage }),
            // sortBy: "createdAt",
            // sortOrder: "desc",
            ...(filter && { range_by: filter, startDate: startDate, endDate: endDate }),
            ...(status && status !== 'None' ? { status } : {}),
            ...(design_kind && design_kind !== 'None' ? { design_kind } : {}),
            ...(fabric_status && fabric_status !== 'None' ? { fabric_status } : {}),
            ...(tabSearch ? { status: tabSearch } : {}),
            download
        };
        try {
            const response = await instance.get('/Order/SubOrders', { params });
            if (download) {
                DownloadExportData(response.data);
                setDownload(false);
            } else {
                const formatteddata = response?.data?.data?.map((suborder, index) => ({
                    sno: index + 1,
                    order_id: suborder?.sub_order_id,
                    name: suborder?.Customer?.name,
                    location: suborder?.Customer?.location,
                    design_kind: suborder?.design_kind,
                    Orderstatus: suborder?.status,
                    Assignperson: suborder?.Admin?.name ? suborder?.Admin?.name : "Unassigned",
                    Deadline: suborder?.deadline,
                    // Assigntailor: suborder?.assigned_tailor ? suborder?.assigned_tailor : "Unassigned",
                    consultationsleft: suborder?.fabric_given === true ? "Yes" : "No",
                    fabricstatus: suborder?.fabric_status,
                    amount: suborder?.amount,
                    suborderdata: suborder,
                    suborder: 'Add Document & Payment',
                    preview: 'Add Image'
                    // DateofBith: suborder?.Customer?.dob,
                    // gender: suborder?.Customer?.Gender,
                    // assign: suborder?.fabric_status,
                    // size: suborder?.size,
                    // Status: suborder?.customer_id?.status === true ? "Active" : "Inactive",
                }))
                setSubOrder(formatteddata)
                setTotalPages(response?.data?.totalPages);
                setCurrentPages(response?.data?.currentPage);
                setTotalcount(response?.data?.total);
            }
        }
        catch (error) {
            console.error('Error fetching orders:', error.message);
        } finally {
            setLoading(false);
        }
    }

    // const subordersDownload = async () => {
    //     try {
    //         setLoading(true);

    //         const response = await instance.get(`/Order/SubOrders?download=true&limit=${totalpages * rowsperpage}`);
    //         //   console.log(response.data);

    //         DownloadExportData(response.data);
    //     } catch (error) {
    //         console.error('Error fetching orders:', error.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    useEffect(() => {
        fetchsuborder(search, currentPage, rowsperpage, tabSearch, download, filter, startDate, endDate, fabric_status, design_kind, status);
        setLoading(true);
        setgetSubOrder(false)
    }, [getSubOrder, search, currentPage, rowsperpage, tabSearch, download, filter, startDate, endDate]);


    // Handle Row Click for view order
    // const handleViewClick = (suborder) => {
    //     setSelectedsubOrder(suborder.suborderdata); // Set selected employee data
    //     setopenviewDialog(true)
    // }

    // Handle Row Click for assign order
    const handleAssignClick = (suborder) => {
        if (suborder.suborderdata.status === "Canceled") {
            setstatusDialog(false)
        } else {
            setSelectedsubOrder(suborder.suborderdata); // Set selected order data
            setstatusDialog(true)
        }
    }

    const handleAssigntailorClick = (suborder) => {
        setSelectedsubOrder(suborder.suborderdata); // Set selected order data
        setAssignDialog(true); // Open the popup
    };

    // Handle Row Click for set deadline suborder
    const handleDeadlinetimeClick = (suborder) => {
        if (suborder.suborderdata.status === "Canceled") {
            setdeleteDialog(false)
        } else {
            setSelectedsubOrder(suborder.suborderdata)
            setdeleteDialog(true)
        }
    }

    //Handle Image Adding for adding image
    const handleAddImageClick = (suborder) => {
        if (suborder.suborderdata.status === "Canceled") {
            setImageDialog(false)
        } else {
            setSelectedsubOrder(suborder.suborderdata);
            setImageDialog(true)
        }
    }

    // Handle Row Click for set document suborder
    const handleAdddocumnentClick = (suborder) => {
        if (suborder.suborderdata.status === "Canceled") {
            setCommonDialog(false)
        } else {
            setSelectedsubOrder(suborder.suborderdata);
            setCommonDialog(true)
        }
    }

    // Handle Row Click for set suborder
    const handleOrderstatus = (suborder) => {
        if (suborder.suborderdata.status === "Canceled") {
            setOpenConsultationDialog(false)
        } else {
            setSelectedsubOrder(suborder.suborderdata)
            setOpenConsultationDialog(true)
        }
    }

    // Handle Row Click for set suborder
    const handleFabricstatus = (suborder) => {
        if (suborder.suborderdata.status === "Canceled") {
            setOpenLoginDialog(false)
        } else {
            setSelectedsubOrder(suborder.suborderdata)
            setOpenLoginDialog(true)
        }
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Menu close handler
    const handleCloseFilter = () => {
        setAnchorEl(null);
    };

    const handleOrderClick = (suborder) => {
        navigate(`/admin/subordersinfo/${suborder.suborderdata._id}`);

    };

    // Apply Filter Handler
    const handlesubApplyFilter = () => {
        fetchsuborder(search, currentPage, rowsperpage, tabSearch, false, filter, startDate, endDate, fabric_status, design_kind, status);
        setAnchorEl(null);
    };


    const handleresetCloseFilter = () => {
        setStatus('')
        SetDesignType('')
        SetFabricStatus('')
        setCurrentPages(1);
        setgetSubOrder(true)
        setAnchorEl(null);
    };




    return (
        <>
            <Topbar />
            <section className='admin-catalogue'>
                <PageHeader
                    title={title}
                    files={true}
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    showButton={false}
                    setSearch={setSearch}
                    Download={() => setDownload(true)}
                />
                <SubHeader
                    isAvailable={"suborders"}
                    // menu={true}
                    // tabsData={tabsData}
                    filter={true}
                    isVisible={true}
                    isSuborderPage={true} //apply filter
                    tabSearch={tabSearch}
                    setTabSearch={setTabSearch}
                    statusOptions={statusOptions}
                    designkindoptins={designkindoptins}
                    design_kind={design_kind}
                    SetDesignType={SetDesignType}
                    SetFabricStatus={SetFabricStatus}
                    fabric_status={fabric_status}
                    fabricStatusOptions={fabricStatusOptions}
                    status={status}
                    setStatus={setStatus}
                    anchorEl={anchorEl}
                    open={open}
                    handleClick={handleClick}
                    handleCloseFilter={handleCloseFilter}
                    handlesubApplyFilter={handlesubApplyFilter}
                    handleClearFilter={handleresetCloseFilter}
                />
                {loading ? (
                    <div className='loader-section'>
                        <CircularProgress />
                    </div>
                ) : (
                    <CommonTable
                        columns={columns}
                        rows={suborders}
                        openDialog={openDialog}
                        setOpenDialog={setOpenDialog}
                        openviewDialog={openviewDialog}
                        setopenviewDialog={setopenviewDialog}
                        banner={true}
                        // deadline={true}
                        suborder={true}
                        handleOrderClick={handleOrderClick}
                        handleAssignClick={handleAssignClick}
                        handleAssigntailorClick={handleAssigntailorClick}
                        handleDeadlinetimeClick={handleDeadlinetimeClick}
                        handleAdddocumnentClick={handleAdddocumnentClick}
                        handleAddImageClick={handleAddImageClick}
                        totalpages={totalpages}
                        rowsperpage={rowsperpage}
                        totalCount={totalCount}
                        currentPage={currentPage}
                        setCurrentPages={setCurrentPages}
                        commonDialog={commonDialog}
                        setCommonDialog={setCommonDialog}
                        openConsultationDialog={openConsultationDialog}
                        setOpenConsultationDialog={setOpenConsultationDialog}
                        handleOrderstatus={handleOrderstatus}
                        openLoginDialog={openLoginDialog}
                        setOpenLoginDialog={setOpenLoginDialog}
                        handleFabricstatus={handleFabricstatus}

                    />
                )}
                <Vieworder
                    openviewDialog={openviewDialog}
                    setopenviewDialog={setopenviewDialog}
                    selectedsubOrder={selectedsubOrder}
                    setSelectedsubOrder={setSelectedsubOrder}
                    getSubOrder={getSubOrder}
                    mode="suborders"
                />
                <Assignorder
                    statusDialog={statusDialog}
                    setstatusDialog={setstatusDialog}
                    selectedsubOrder={selectedsubOrder}
                    setgetSubOrder={setgetSubOrder}
                    mode="suborders"
                />
                {/* <Assigntailor
                    assignDialog={assignDialog}
                    setAssignDialog={setAssignDialog}
                    selectedsubOrder={selectedsubOrder}
                    setgetSubOrder={setgetSubOrder}
                    mode="suborders" // To differentiate the mode
                /> */}
                <Deadlineorder
                    deleteDialog={deleteDialog}
                    setdeleteDialog={setdeleteDialog}
                    selectedsubOrder={selectedsubOrder}
                    setgetSubOrder={setgetSubOrder}
                    mode="suborders" // To differentiate the mode
                />
                <Adddocuments
                    selectedsubOrder={selectedsubOrder}
                    setCommonDialog={setCommonDialog}
                    commonDialog={commonDialog}
                    setgetSubOrder={setgetSubOrder}
                />
                <UploadImage
                    selectedsubOrder={selectedsubOrder}
                    setgetSubOrder={setgetSubOrder}
                    imageDialog={imageDialog}
                    setImageDialog={setImageDialog}
                />
                <Orderstatus
                    openConsultationDialog={openConsultationDialog}
                    setOpenConsultationDialog={setOpenConsultationDialog}
                    selectedsubOrder={selectedsubOrder}
                    setgetSubOrder={setgetSubOrder}
                    mode="suborders" // To differentiate the mode
                />
                <Fabricstatus
                    openLoginDialog={openLoginDialog}
                    setOpenLoginDialog={setOpenLoginDialog}
                    selectedsubOrder={selectedsubOrder}
                    setgetSubOrder={setgetSubOrder}
                    mode="suborders" // To differentiate the mode
                />
            </section>
        </>
    )

}
export default Suborders;
